export default "__VITE_ASSET__Va_b_20r__"